import React from "react";
import quoteImg from "../../assets/icons/quote.png";
import "./ReviewItem.scss";

const ReviewItem = ({ review }) => {
  return (
    <div className="review-item">
      <img src={quoteImg} className="quote" alt="quote" />
      <p className="review-description">{review?.description}</p>
      <h5 className="review-client">{`${review?.firstName} ${review?.lastName}`}</h5>
    </div>
  );
};

export default ReviewItem;
